/**
 * Created by Mark on 23/11/2016.
 */


import request from 'reqwest';
import when from 'when';
import UserStore from '../store/user-store.js';
class BaseService {

    getAPI(){
        if (window.location.href.indexOf("localhost") > -1) {
            return 'https://api.languagenut.com/'
            //return 'https://services_gamma.languagenut.com/'
        } else if (window.location.href.indexOf("gamma") > -1) {
            return 'https://services_gamma.languagenut.com/'
        } else if (window.location.href.indexOf("asia") > -1) {
            return 'https://asia_api.languagenut.com/'
        }

        return 'https://api.languagenut.com/'
    }

    addDataConstants(data){
        data.token      = sessionStorage.getItem('USER_TOKEN') || sessionStorage.getItem('token');
        data.accountUID  = UserStore.account.account_uid;
        return data;
    }

    handleService(url, data) {
        return when(request({
            url:url,
            method: 'post',
            data:this.addDataConstants(data),
            crossOrigin: true,
            type: 'json'
        }));
    }

    call(url , data){
        return new Promise(function(resolve){
            this.handleService(this.getAPI() + url , data).then(function(response){

                if(response.token || response.newToken)
                {
                    sessionStorage.setItem('USER_TOKEN' , response.token || response.newToken);
                }
                if (response.Error && response.Error == "U1" && response.msg && response.msg == "invalidToken") {
                    window.location.hash = "#/";
                    return;
                }
                
                resolve(response);
            });
        }.bind(this));
    }


}


export default new BaseService();